import React from 'react';
import Section from './Section';

const AssocieSe = () => {
  const basePath = '/imagem';
  const bgUrl = `url(${basePath}/capa-home.png)`;

  return (
    <Section
      id="associe-se"
      bgClass="bg-cover bg-center"
      title=""
      className="pb-0 relative"
      style={{ backgroundImage: bgUrl }}
    >
      {/* accessible hidden heading */}
      <h2 className="sr-only">Associe-se</h2>
      {/* dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="relative py-16 z-10">
        <p className="max-w-3xl mx-auto text-center mb-6 text-secondary-light font-semibold">
          Seja parte da entidade que representa e defende os profissionais das agrárias de Goiás. Associar-se é fortalecer sua profissão e participar ativamente das decisões que moldam o futuro do agro.
        </p>
        <div className="flex justify-center mt-8 gap-4">
          <a 
            href="https://forms.gle/19xC5cN8AdDZC2r76"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-navy py-2 px-6 rounded-full font-semibold hover:bg-gray-100 transition">
            Associe-se
          </a>
          <a
            href={process.env.PUBLIC_URL + '/documentos/Estatuto_AEAGO_ocr.pdf'}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-navy py-2 px-6 rounded-full font-semibold hover:bg-gray-100 transition"
          >
            Estatuto
          </a>
        </div>
      </div>
  </Section>
  );
};

export default AssocieSe;
